<template>
  <div
    :class="{ 'bg-white': !nightMode, 'bg-dark': nightMode }"
    class="pt-5 p-st"
  >
    <div
      class="container"
      data-aos="fade"
      data-aos-once="true"
      data-aos-duration="1000"
    >
      <!-- start of hero section -->
      <div
        class="
          hero-section
          row
          align-items-center
          hero-img
          justify-content-center
        "
      >
        <div class="hero-img">
          <div class="layer">
            <img :src="picture" alt="User Name" />
          </div>
        </div>
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 pt-2">
          <div
            class="home-title"
            :class="{ pgray: !nightMode, 'text-light': nightMode }"
          >
            <div class="text-center" style="color: #de8f3c">Wahyu Saragih</div>
          </div>
          <div style="color: #de8f3c">
            <vue-typer
              class="d-flex justify-content-center text-primary"
              :text="text1"
              :repeat="Infinity"
              :shuffle="false"
              initial-action="erasing"
              :pre-type-delay="70"
              :type-delay="70"
              :pre-erase-delay="1980"
              :erase-delay="150"
              erase-style="select-back"
              :erase-on-complete="false"
              caret-animation="smooth"
            ></vue-typer>
          </div>
          <div>
            <p v-html="description"></p>
          </div>
          <div class="text-center pb-4">
            <button
              class="btn btn-outline-secondary mx-2"
              @click="open('github')"
              v-tooltip.bottom="'GitHub'"
            >
              <i class="fab fa-github"></i>
            </button>
            <button
              class="btn btn-outline-secondary mx-2"
              @click="open('linkedin')"
              v-tooltip.bottom="'LinkedIn'"
            >
              <i class="fab fa-linkedin"></i>
            </button>
            <!-- <button
              class="btn btn-outline-secondary mx-2"
              @click="open('resume')"
              v-tooltip.bottom="'Resume'"
            >
              <i class="fa fa-file"></i>
            </button> -->
          </div>
        </div>
      </div>
      <!-- end of hero section -->
    </div>
  </div>
</template>

<script>
import info from "../../info";
import Wave from "./helpers/Wave";
import { VueTyper } from "vue-typer";

export default {
  name: "Home",
  components: {
    Wave,
    "vue-typer": VueTyper,
  },
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      picture: info.flat_picture,
      description: info.description,
      name: info.name,
      linkedin: info.links.linkedin,
      github: info.links.github,
      behance: info.links.behance,
      resume: info.links.resume,
      text1: ["UI/UX Designer", "Web Developer", "Product Designer", "Technician"],
    };
  },
  methods: {
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "github":
          window.open(this.github, "_blank");
          break;
        case "resume":
          window.open(this.resume, "_blank");
          break;
      }
    },
  },
};
</script>

<style scoped>
.vue-typer {
  font-family: monospace;
}

.home-title {
  font-size: 32px;
  font-weight: 500;
}

img {
  max-width: 800px;
  max-height: 400px;
  margin-top: 0px;
  /* transform: rotateY(180deg); */
  z-index: 3;
}

@media only screen and (max-width: 580px) {
  img {
    object-fit: contain;
    border-radius: 50%;
    height: 300px;
    width: 300px;
    /* margin-top: 10px;
    margin-bottom: 10px; */
    /* border: 2px solid rgb(205, 205, 205); */
  }
}

.fa {
  font-size: 15px;
}

.btn {
  border-color: #de8f3c;
  color: #de8f3c;
}

.btn:hover {
  background-color: #de8f3c;
  border-color: #de8f3c;
  color: white;
}

.btn:focus {
  background-color: #de8f3c;
  border-color: #de8f3c;
  color: white;
}

.btn:focus {
  outline: none !important;
}

p {
  text-align: justify;
  font-weight: 400;
}

/* LEAVES */
/*------------------------------------------------------------------------------------------*/

/*------------------------------------------------------------------------------------------*/
/* 7. Pages Styles */
/*------------------------------------------------------------------------------------------*/
/* 1. Homepage Styles */
/*--------------------*/
/* 1. Hero Section Styles */
/*------------------------*/
@media (max-width: 991px) {
  .hero-section .hero-img {
    position: relative;
    /* height: 80vw; */
    max-height: 400px;
    /* width: 80vw; */
    max-width: 400px;
    margin: auto;
  }
}
.hero-section .hero-img .layer {
  position: relative;
  width: 100%;
}
@media (min-width: 992px) {
  .hero-section .hero-img .layer {
    top: 0;
    left: 0;
    -webkit-transition: -webkit-transform 1s ease;
    transition: -webkit-transform 1s ease;
    transition: transform 1s ease;
    transition: transform 1s ease, -webkit-transform 1s ease;
  }
}
/* @media (max-width: 991px) {
  html[dir="ltr"] .hero-section .hero-img .layer {
    left: 50%;
  }
  html[dir="rtl"] .hero-section .hero-img .layer {
    right: 50%;
  }
} */
.hero-section .hero-img .layer:first-of-type {
  height: 100%;
  -webkit-mask-image: url("../assets/images/splash.png");
  mask-image: url("../assets/images/splash.png");
  /* -webkit-mask-repeat: no-repeat; */
  /* mask-repeat: no-repeat; */
  /* -webkit-mask-position: center; */
  /* mask-position: center; */
  /* -webkit-mask-size: contain; */
  /* mask-size: contain; */
  -webkit-mask-size: 235%;
  mask-size: 235%;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center bottom;
  mask-position: center bottom;
}
.hero-section .hero-img .layer:first-of-type:before {
  content: "";
  position: absolute;
}
@media (min-width: 992px) {
  .hero-section .hero-img .layer:first-of-type:before {
    z-index: 1;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(hsl(var(--main-color-one))),
      to(hsl(var(--main-color-two)))
    );
    background: linear-gradient(
      to right,
      hsl(var(--main-color-one)) 0%,
      hsl(var(--main-color-two)) 100%
    );
  }
}
@media (max-width: 991px) {
  .hero-section .hero-img .layer:first-of-type {
    top: 50%;
  }
  html[dir="ltr"] .hero-section .hero-img .layer:first-of-type {
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  html[dir="rtl"] .hero-section .hero-img .layer:first-of-type {
    -webkit-transform: translate(50%, -50%);
    transform: translate(50%, -50%);
  }
  .hero-section .hero-img .layer:first-of-type:before {
    bottom: 0;
    height: 80%;
    width: 80%;
    background-color: hsl(var(--main-color-one));
    border-radius: 50%;
  }
  html[dir="ltr"] .hero-section .hero-img .layer:first-of-type:before {
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  html[dir="rtl"] .hero-section .hero-img .layer:first-of-type:before {
    right: 50%;
    -webkit-transform: translateX(50%);
    transform: translateX(50%);
  }
}
.hero-section .hero-img .layer:last-of-type {
  height: 50%;
  overflow: hidden;
}
/* @media (max-width: 991px) {
  .hero-section .hero-img .layer:last-of-type {
    top: 0;
  }
  html[dir="ltr"] .hero-section .hero-img .layer:last-of-type {
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  html[dir="rtl"] .hero-section .hero-img .layer:last-of-type {
    -webkit-transform: translateX(50%);
    transform: translateX(50%);
  }
  .hero-section .hero-img .layer:last-of-type img {
    height: 200%;
    width: 200%;
  }
  html[dir="ltr"] .hero-section .hero-img .layer:last-of-type img {
    -webkit-transform: translateX(-25%);
    transform: translateX(-25%);
  }
  html[dir="rtl"] .hero-section .hero-img .layer:last-of-type img {
    -webkit-transform: translateX(25%);
    transform: translateX(25%);
  }
}
.hero-section .hero-img .layer img {
  display: block;
  -webkit-filter: drop-shadow(2px 4px 6px black);
  filter: drop-shadow(2px 4px 6px black);
} */
@media (min-width: 992px) {
  .hero-section .hero-img .layer img {
    position: relative;
    z-index: 2;
    height: calc(100vh - 70px);
    max-width: 100%;
    margin: auto;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}
/* @media (max-width: 991px) {
  .hero-section .hero-img .layer img {
    height: 100%;
    width: 100%;
    -o-object-fit: contain;
    object-fit: contain;
  }
} */
.hero-section .hero-text {
  text-align: center;
}
@media (min-width: 992px) {
  .hero-section .hero-text {
    position: absolute;
    z-index: 3;
    top: 45%;
    width: 90%;
    text-shadow: 0px 0px 20px hsl(var(--dark-color));
  }
  html[dir="ltr"] .hero-section .hero-text {
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
  html[dir="rtl"] .hero-section .hero-text {
    right: 50%;
    -webkit-transform: translateX(50%);
    transform: translateX(50%);
  }
}
@media (max-width: 991px) {
  .hero-section .hero-text {
    width: 90vw;
  }
}
.hero-section .hero-text h2 {
  margin-bottom: 30px;
}
html[dir="ltr"] .hero-section .hero-text h2 {
  text-transform: capitalize;
}
@media (min-width: 992px) {
  .hero-section .hero-text h2 {
    color: hsl(var(--light-color)) !important;
    font-size: 3rem;
  }
}
@media (max-width: 991px) {
  .hero-section .hero-text h2 {
    color: hsl(var(--bg-color-reverse));
    font-size: 2rem;
  }
}
@media (min-width: 992px) {
  .hero-section .hero-text .btn {
    color: hsl(var(--light-color));
    border-color: hsl(var(--light-color));
  }
  .hero-section .hero-text .btn:hover {
    background-color: hsl(var(--light-color));
    color: hsl(var(--dark-color));
    text-shadow: none;
  }
}
@media (max-width: 991px) {
  .hero-section .hero-text .btn {
    color: hsl(var(--bg-color-reverse));
    border-color: hsl(var(--bg-color-reverse));
  }
  .hero-section .hero-text .btn:hover {
    background-color: hsl(var(--bg-color-reverse));
    color: hsl(var(--bg-color-one));
  }
}
.hero-section .hero-text .btn:focus {
  outline: none;
}
.enable-focus-style .hero-section .hero-text .btn:focus {
  -webkit-box-shadow: 0 0 0 3px hsla(var(--main-color-two), 70%);
  box-shadow: 0 0 0 3px hsla(var(--main-color-two), 70%);
}
.hero-section .social,
.hero-section .scroll-down {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  bottom: 20px;
  font-size: 18px;
  text-transform: uppercase;
}
@media (max-width: 991px) {
  .hero-section .social,
  .hero-section .scroll-down {
    display: none;
  }
}
.hero-section .social.social:before,
.hero-section .social.scroll-down:after,
.hero-section .scroll-down.social:before,
.hero-section .scroll-down.scroll-down:after {
  content: "";
  display: inline-block;
  height: 2px;
  width: 30px;
  background-color: hsl(var(--t-color-two));
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.hero-section .social.social a:hover,
.hero-section .social.scroll-down:hover,
.hero-section .scroll-down.social a:hover,
.hero-section .scroll-down.scroll-down:hover {
  color: hsl(var(--t-color-one));
}
.hero-section .social.social a:hover:after,
.hero-section .social.scroll-down:hover:after,
.hero-section .scroll-down.social a:hover:after,
.hero-section .scroll-down.scroll-down:hover:after {
  background-color: hsl(var(--t-color-one));
}
html[dir="ltr"] .hero-section .social {
  left: 30px;
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  -webkit-transform-origin: left top;
  transform-origin: left top;
}
html[dir="rtl"] .hero-section .social {
  right: 30px;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  -webkit-transform-origin: right top;
  transform-origin: right top;
}
html[dir="ltr"] .hero-section .social:before {
  margin-right: 20px;
}
html[dir="rtl"] .hero-section .social:before {
  margin-left: 20px;
}
.hero-section .social ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
html[dir="ltr"] .hero-section .social ul {
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
html[dir="rtl"] .hero-section .social ul {
  -webkit-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
}
html[dir="ltr"] .hero-section .social ul li {
  -webkit-transform: rotateX(0deg) rotateY(180deg) rotateZ(90deg);
  transform: rotateX(0deg) rotateY(180deg) rotateZ(90deg);
}
html[dir="rtl"] .hero-section .social ul li {
  -webkit-transform: rotateX(0deg) rotateY(-180deg) rotateZ(-90deg);
  transform: rotateX(0deg) rotateY(-180deg) rotateZ(-90deg);
}
html[dir="ltr"] .hero-section .social ul li:not(:last-of-type) {
  margin-right: 20px;
}
html[dir="rtl"] .hero-section .social ul li:not(:last-of-type) {
  margin-left: 20px;
}
.hero-section .social ul li a:focus {
  outline: none;
}
.enable-focus-style .hero-section .social ul li a:focus {
  -webkit-box-shadow: 0 0 0 3px hsla(var(--main-color-two), 70%);
  box-shadow: 0 0 0 3px hsla(var(--main-color-two), 70%);
}
html[dir="ltr"] .hero-section .scroll-down {
  right: 30px;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  -webkit-transform-origin: right top;
  transform-origin: right top;
}
html[dir="rtl"] .hero-section .scroll-down {
  left: 30px;
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  -webkit-transform-origin: left top;
  transform-origin: left top;
}
.hero-section .scroll-down a {
  text-transform: inherit;
}
.hero-section .scroll-down a:focus {
  outline: none;
}
.enable-focus-style .hero-section .scroll-down a:focus {
  -webkit-box-shadow: 0 0 0 3px hsla(var(--main-color-two), 70%);
  box-shadow: 0 0 0 3px hsla(var(--main-color-two), 70%);
}
html[dir="ltr"] .hero-section .scroll-down:after {
  margin-left: 20px;
}
html[dir="rtl"] .hero-section .scroll-down:after {
  margin-right: 20px;
}
/* @media (min-width: 992px) {
  .hero-section {
    position: relative;
    height: calc(100vh - 70px);
  }
  .hero-section.parallax-animation:hover .layer {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
  }
} */
@media (max-width: 991px) {
  .hero-section {
    min-height: calc(100vh - 70px);
    display: grid;
    place-content: center;
    /* padding-top: 80px;
    padding-bottom: 80px; */
  }
}
</style>
